import React from 'react'
// import { useState, useEffect } from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { actlistData, joinAuction } from "../../actions/index";
import { useForm } from "react-hook-form";
import { BASE_PATH } from ".././../constants/Global";
import { Link, useHistory } from "react-router-dom";
import dateFormat from "dateformat";
import { auctiondefaultLogo } from "../../constants/Images";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import { maxStringNew } from "../../Helpers/Helpers";
import { playerdefaultLogo } from "../../constants/Images";
import { useMediaQuery } from "react-responsive";
import ImageCropper from "../cropper/ImageCropper";
import { bat } from "../../constants/Images";
import { ball } from "../../constants/Images";
import { wkeeper } from "../../constants/Images";
export default function JoinauctionCode3() {
  const [isDisabled, setDisabled] = useState(false);
  // const getpageData = useSelector((state) => state.setJoinAuction);
  const loginuser = useSelector((state) => state.setUserlog);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm();
  const [othersp3, setOthersp3] = useState(false);
  const [sp3, setsp3] = useState("");

  const [batting, setBatting] = useState("none");
  const [getpageData, setgetpageData] = useState('');
  const [otherBatting, setOtherBatting] = useState(0);
  const [otherBowling, setOtherBowling] = useState(0);
  const [bowling, setBowling] = useState(0);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [catData, setcatData] = useState([]);
  const [isjoinanother, setisjoinanother] = useState(false)
  const [catid, setcatid] = useState("");
  const [isbat, setisbat] = useState(false);
  const [isbol, setisbol] = useState(false);
  const [iswkeep, setiswkeep] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [defimg, setdefimg] = useState(playerdefaultLogo);
  const [defimg2, setdefimg2] = useState("");
  const [auctype, setauctype] = useState(getpageData.response?.data?.detail && getpageData?.response?.data.detail.acttype
    ? getpageData.response.data.detail.acttype
    : "0")

  const [sp1opt, setsp1opt] = useState(['All Rounder', 'Batting All Rounder', 'Bowling All Rounder', 'All Rounder Wicketkeeper', 'Batsman', 'Bowler', 'Wicket Keeper', 'Batter', 'Other']);

  const [sp2opt, setsp2opt] = useState(['Right Hand', 'Left Hand', 'Right Hand Batsman', 'Left Hand Batsman', 'Right Hand Opener', 'Left Hand Opener', 'Right Hand Middle Order', 'Left Hand Middle Order']);
  const [sp3opt, setsp3opt] = useState(['Right Arm Fast', 'Right Arm Medium', 'Left Arm Fast', 'Left Arm Medium', 'Off-Break', 'Leg-Break', 'Left Arm Orthodox', 'Left Arm Chanaman']);

  const [joinauctionAid, setjoinauctionAid] = useState(
    getpageData.response?.data?.detail && getpageData?.response?.data.detail.aid
      ? getpageData.response.data.detail.aid
      : null
  );
  const [auctionCode, setauctionCode] = useState(
    getpageData?.response?.data.detail && getpageData?.values.acode
      ? getpageData.values.acode
      : null
  );
  const [data, setData] = useState('');


  const [playingStyle, setPlayingStyle] = useState("");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  const history = useHistory({ forceRefresh: true });
  var savenew = 0;
  let logo_pic = "";

  const fetchallData = (values) => {
    console.log('fetching api')

    setDisabled(true);
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: 0, token: 0 }]),
      },
    };
    console.log("")
    DataService.JoinauctionCode(values, hdr)
      .then((res) => {
        let response = res.data;
        console.log(values)
        console.log('response is.....')
        console.log(response)
        setauctype(response.data.detail.acttype)


        toast.dismiss(toastContainerId);
        setgetpageData({ response, values })

        // dispatch(joinAuction({ response, values }));

        // if (response.success == true) {
        // if (response.data.detail.reg_player_on === "1") {
        //   console.log("code submit")
        //   console.log(response.data)
        //   localStorage.setItem("auction_id", response.data.detail.aid);

        //   toast.success("Now you can Join", {
        //     theme: "dark",
        //     position: "bottom-center",
        //   });
        //   history.push(BASE_PATH + "join-auction");
        // }
        // else {
        //   setjoindata(response.data.detail)
        // }


        // } else {
        //   toast.error(response.msg, { theme: "colored" });
        // }

        // setDisabled(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Serverrr Error", { theme: "colored" });
        setDisabled(false);
      });
    // localStorage.removeItem('acode')
  };

  const fetchcatData = async (aid) => {
    // setActive(true);

    var hdr = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization": JSON.stringify([{ 'cid': 0, 'token': 0 }])
      }
    }

    await DataService.listCategory({ 'aid': aid }, hdr)

      .then(res => {
        console.log('categories response')
        console.log(res)
        let response = res.data;

        if (response.success == true) {

          let responsedata = response.data;
          console.log(responsedata);
          setcatData(responsedata.list);
        }
        // setActive(false);

      }).catch(() => {
        console.log('Not valid')
        // setActive(false);
      })
  };

  useEffect(() => {
    var values = {
      'acode': localStorage.getItem('acode')
    }
    console.log('initial state')
    fetchallData(values)


  }, [])
  useEffect(() => {
    console.log('get page data ')
    console.log(getpageData)
    if (getpageData != '') {
      localStorage.setItem('auction_id', getpageData.response.data.detail.aid)
      console.log(getpageData.response.data.detail)
      setData(getpageData.response.data.detail)
      // fetchcatData(getpageData.response.data.detail.aid)
      setcatData(getpageData.response.data.detail.catlist);


    }


  }, [getpageData])
  useEffect(() => {
    if (loginuser) {
      if (loginuser.photo) {
        setdefimg(loginuser.photo)
        setdefimg2(loginuser.photo.split('/')[4])
      }
      setValue('pname', loginuser.cperson)
      setValue('mobno', loginuser.mobno)
      setValue('fname', loginuser.fname)
    }
  }, [loginuser])

  const onSubmit = (values) => {
    setDisabled(true);
    console.log('aid ')
    console.log(localStorage.getItem('auction_id'))

    if (document.getElementById("logo_pic") != null) {
      logo_pic = document.getElementById("logo_pic").value;
    }
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: 0, token: 0, aid: localStorage.getItem('auction_id') }]),
      },
    };
    var icon = ''
    if (isbat == true) {
      if (icon == '') {
        icon += 'bat.png'
      }
      else {
        icon += ',bat.png'
      }

    }
    if (isbol == true) {
      if (icon == '') {
        icon += "ball.png"
      }
      else {
        icon += ",ball.png"
      }

    }
    if (iswkeep == true) {
      if (icon == '') {
        icon += "gloves.png"
      }
      else {
        icon += ",gloves.png"
      }

    }
    if (croppedImage == "" && defimg == playerdefaultLogo) {
      alert('Please add your profile picture !!')
      return 0
    }
    else {
      if (croppedImage == "") {

        values["a_photo"] = defimg2;
      }
      else {
        values["logo_pic"] = croppedImage;

      }
    }

    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
    });
    values["icons"] = icon;
    if (auctype == 0) {
      values["spcf3"] = sp3;
    }
    console.log('pl submitted values')
    console.log(values)
    DataService.joinPlayer(values, hdr)
      .then((res) => {
        let response = res.data;
        console.log(" join resp")
        console.log(response)
        console.log(values)

        toast.dismiss(toastContainerId);

        if (response.success == true) {
          let submitdata = [response.data.new];

          // let responsedata = {};
          // responsedata = {
          //   responsedata: {
          //     path: response.data.path,
          //     list: getpageData
          //       ? [...submitdata, ...getpageData.responsedata.list]
          //       : [...submitdata],
          //   },
          // };
          // dispatch(playerlistData(responsedata));

          toast.success('Successfully Joined', {
            theme: "dark",
            position: "bottom-center",
          });
          localStorage.setItem('cjoined', data.auctionname)
          savenew ? reset() : history.push(`${BASE_PATH}join-auction-success`);
        } else {
          toast.error(response.msg, { theme: "colored" });
        }

        setDisabled(false);
      })
      .catch(() => {
        console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", { theme: "colored" });
        setDisabled(false);
      });
  };


  var batstyle = {
    backgroundColor: 'white'
  }
  var bolstyle = {
    backgroundColor: 'white'
  }
  var wkeepstyle = {
    backgroundColor: 'white'
  }
  if (isbat == true) {
    batstyle = {
      backgroundColor: 'black',
      color: 'white',
      border: '3px solid blue'
    }
  }
  if (isbol == true) {
    bolstyle = {
      backgroundColor: 'black',
      color: 'white',
      border: '3px solid blue'
    }
  }
  if (iswkeep == true) {
    wkeepstyle = {
      backgroundColor: 'black',
      color: 'white',
      border: '3px solid blue'
    }
  }
  return (
    <div>
      {/* <Navigationtitle data={match} /> */}

      {getpageData ? (
        <div
          id="top-categories"
          className="top-cat-area default-padding bottom-less"
        >
          <div className="container-fluid">
            <div className="row">
              <div id="contact-us" className="reg-area">
                <div className="container-fluid">
                  <div
                    className="row joinheader"
                    style={{
                      backgroundColor: "rgb(248 248 251)",
                      margin: "20px 0px",
                      padding: "25px 6px",
                      borderRadius: "2px",
                    }}
                  >
                    <div className="item vertical">
                      <div className="info join-auction-form">
                        <div className="col-md-6 join-auction-info">
                          {data ? (
                            <div className="row onlyflex">
                              <div className="col-md-2 join-auction-padding">
                                <Image
                                  fallback={
                                    <Shimmer width={50} height={50} />
                                  }
                                  src={
                                    data && data.alogo != null
                                      ?
                                      auctiondefaultLogo
                                      // getpageData.response.data.detail.path
                                      // .getpageData.response.data.detail
                                      // .alogo
                                      : auctiondefaultLogo
                                  }
                                ></Image>
                              </div>

                              <div className="col-md-10">
                                <h5>{data.auctionname} </h5>
                                <p>Auction on : {data.dt}</p>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                        {isjoinanother && <div className="col-md-6 join-auction-info-form">
                          <div className="row">
                            <form
                              onSubmit={handleSubmitCode(auctionCodeSubmit)}
                              action=""
                              autoComplete="off"
                              encType="multipart/form-data"
                            >
                              <div className="col-md-4">
                                <div className="form-group">
                                  <input
                                    className="form-control"
                                    type="text"
                                    maxLength={9}
                                    minLength={8}
                                    placeholder="Enter A-Code"
                                    {...registerCode("acode", {
                                      required: true,
                                      required: "required field.",
                                    })}
                                  />
                                  {errorsCode.acode && (
                                    <p className="text-error">
                                      {errorsCode.acode.message}
                                    </p>
                                  )}
                                </div>
                              </div>

                              <div className="col-md-8 join-auction-padding">
                                <div className="form-group">
                                  <button className="button" type="submit">
                                    {" "}
                                    SUBMIT
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>}
                        {/* {!isjoinanother && <button onClick={() => setisjoinanother(!isjoinanother)} className="joinanotherbtn">Join Another</button>} */}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="reg-items">
                      <div className="col-md-5  reg-form">
                        <form
                          onSubmit={handleSubmit(onSubmit)}
                          action=""
                          autoComplete="off"
                          encType="multipart/form-data"
                        >
                          <div className="row">
                            <div className="col-md-12">
                              <input
                                {...register("acode")}
                                type="hidden"
                                defaultValue={localStorage.getItem('acode')}
                              />
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <div className="col-md-4 margin-top-14px">
                                      <label htmlFor="crop-pic">
                                        {" "}
                                        Profile Pic{/*logo*/}{" "}
                                      </label>
                                    </div>
                                    <div className="col-md-8 margin-top-14px">
                                      {/* <Demo /> */}
                                      <ImageCropper
                                        croppedImage={croppedImage}
                                        setCroppedImage={setCroppedImage}
                                        defaultimage={defimg}
                                        wid={180}
                                      // basepath={aucbasepath}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">

                                  {/* {!loginuser && */}
                                  <div className="row padd15">
                                    <div className="col-md-4">
                                      <div className="form-group text-box-margin nobottommar">
                                        <label>Name</label>

                                      </div>
                                    </div>
                                    <div className="col-md-8">
                                      <div className="form-group text-box-margin">

                                        <input
                                          className="form-control"
                                          type="text"
                                          id="pname"
                                          {...register("pname", {
                                            required: "This is required"
                                          })}
                                        />
                                        {errors.pname && (
                                          <p className="text-error">
                                            {errors.pname.message}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="row padd15">
                                    <div className="col-md-4">
                                      <div className="form-group text-box-margin nobottommar">
                                        {/* <label>{data.show.mobile.label !== "" ? data.show.mobile.label.charAt(0).toUpperCase() + data.show.mobile.label.slice(1) : "Mobile No."}{data.show.mobile.req == '1' && '*'}</label> */}
                                        <label htmlFor="">Mobile No.</label>
                                      </div>
                                    </div>
                                    <div className="col-md-8">
                                      <div className="form-group text-box-margin">

                                        <input
                                          className="form-control"
                                          type="number"
                                          id="mobno"
                                          {...register("mobno", {
                                            required: "This is required"
                                          })}
                                        />
                                        {errors.mobno && (
                                          <p className="text-error">
                                            {errors.mobno.message}
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {/* } */}
                                  {data != '' && data.show.age.show == 1 &&
                                    <div className="row padd15">
                                      <div className="col-md-4">
                                        <div className="form-group text-box-margin nobottommar">
                                          <label> {data?.show.age.label !== "" ? data?.show.age.label.charAt(0).toUpperCase() + data?.show.age.label.slice(1) : "Age"}{data?.show.age.req == '1' && '*'}</label>

                                        </div>
                                      </div>
                                      <div className="col-md-8">
                                        <div className="form-group text-box-margin">

                                          <input
                                            className="form-control"
                                            type="number"
                                            id="age"
                                            {...register("age", {
                                              required: data?.show.age.req == 1 ? "This is required" : false
                                            })}
                                          />
                                          {errors.age && (
                                            <p className="text-error">
                                              {errors.age.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  }
                                  {data != '' && data.show.fname.show == 1 &&

                                    <div className="row padd15">
                                      <div className="col-md-4">
                                        <div className="form-group text-box-margin nobottommar">
                                          <label>{data.show.fname.label !== "" ? data.show.fname.label.charAt(0).toUpperCase() + data.show.fname.label.slice(1) : "Father's name"}{data.show.fname.req == '1' && '*'}</label>

                                        </div>
                                      </div>
                                      <div className="col-md-8">
                                        <div className="form-group text-box-margin">

                                          <input
                                            className="form-control"
                                            type="text"
                                            id="fname"
                                            {...register("fname", {
                                              required: data.show.fname.req == 1 ? "This is required" : false

                                            })}

                                          />
                                          {errors.fname && (
                                            <p className="text-error">
                                              {errors.fname.message}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  }

                                </div>

                              </div>








                              {data != '' && data.show.tname.show == 0 &&
                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <label htmlFor="tshirt">
                                      {" "}
                                      {data.show.tname.label !== "" ? data.show.tname.label.charAt(0).toUpperCase() + data.show.tname.label.slice(1) : "Jerssey Name"}{data.show.tname.req == '1' && '*'}
                                    </label>
                                    <input
                                      placeholder={data.show.tname.label !== "" ? data.show.tname.label : "Jerssey Name"}
                                      className="form-control"
                                      type="text"
                                      {...register("jrnm", {
                                        required: data.show.tname.req == 1 ? "This is required" : false

                                      })}
                                    />
                                    {errors.jrnm && (
                                      <p className="text-error">
                                        {errors.jrnm.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              }
                              {data != '' && data.show.tno.show == 1 &&
                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <label htmlFor="tshirt">
                                      {" "}
                                      {data.show.tno.label !== "" ? data.show.tno.label.charAt(0).toUpperCase() + data.show.tno.label.slice(1) : "Jerssey Number"}{data.show.tno.req == '1' && '*'}
                                    </label>
                                    <input
                                      placeholder="Jersey Number"
                                      className="form-control"
                                      type="number"
                                      {...register("jrno", {
                                        required: data.show.tno.req == 1 ? "This is required" : false

                                      })}
                                    />
                                    {errors.jrno && (
                                      <p className="text-error">
                                        {errors.jrno.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              }
                              {data != '' && data.show.tshirt.show == 1 &&

                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <label htmlFor="tshirt">
                                      {" "}
                                      {data.show.tshirt.label !== "" ? data.show.tshirt.label.charAt(0).toUpperCase() + data.show.tshirt.label.slice(1) : "T-Shirt"}{data.show.tshirt.req == '1' && '*'}
                                    </label>
                                    <input
                                      className="form-control"
                                      type="text"
                                      placeholder="S/M/L/XL/XXL/XXXL"
                                      id="tshirt"
                                      {...register("tshirt", {
                                        required: data.show.tshirt.req == 1 ? "This is required" : false

                                      })}
                                    />

                                    {errors.tshirt && (
                                      <p className="text-error">
                                        {errors.tshirt.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              }
                              {data != '' && data.show.trouser.show == 1 &&

                                <div className="col-md-6">
                                  <div className="form-group text-box-margin">
                                    <label htmlFor="trouser"> {data.show.trouser.label !== "" ? data.show.trouser.label.charAt(0).toUpperCase() + data.show.trouser.label.slice(1) : "Trouser"}{data.show.trouser.req == '1' && '*'}</label>
                                    <input
                                      className="form-control"
                                      id="trouser"
                                      placeholder="S/M/L/XL/XXL/XXXL"
                                      type="text"
                                      {...register("trouser", {
                                        required: data.show.trouser.req == 1 ? "This is required" : false

                                      })}
                                    >

                                    </input>
                                    {errors.trouser && (
                                      <p className="text-error">
                                        {errors.trouser.message}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              }
                              {data != '' && data.extra.length > 0 && data.extra.map((item, index) => {
                                if (item.o) {

                                  var dynamicoptions = item.o.split(',')
                                }
                                return (
                                  <div className="col-md-6">
                                    <div className="form-group text-box-margin">
                                      <label htmlFor="tshirt">
                                        {" "}
                                        {item.l}{item.r == '1' && '*'}
                                      </label>
                                      {item.t == '0' ?
                                        <input
                                          placeholder={item.label}
                                          className="form-control"
                                          type="text"
                                          {...register("extra_" + index, {
                                            required: item.r == 1 ? "This is required" : false
                                          })}
                                        />
                                        :
                                        item.t == '1' ?
                                          <input
                                            placeholder={item.label}
                                            className="form-control"
                                            type="number"
                                            {...register("extra_" + index, {
                                              required: item.r == 1 ? "This is required" : false
                                            })}
                                          /> :

                                          <select
                                            className="form-control"
                                            id={item.label}
                                            type="text"
                                            {...register("extra_" + index, {
                                              required: item.r == 1 ? "This is required" : false

                                            })}
                                          >
                                            <option value="">--select--</option>
                                            {dynamicoptions?.map((el, ind) => {

                                              return (

                                                <option value={el}>{el}</option>
                                              )
                                            })}

                                          </select>
                                      }
                                      {errors.trouser && (
                                        <p className="text-error">
                                          {errors.trouser.message}
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                )
                              })
                              }
                              {(data != '' && data.show.cat.show == 1 && catData.length > 0) &&

                                <div className="col-xs-12 col-sm-12 col-md-4 margin-top-14px-isowner">
                                  <label htmlFor="spcf1">
                                    {" "}
                                    {data.show.cat.label !== "" ? data.show.cat.label.charAt(0).toUpperCase() + data.show.cat.label.slice(1) : "Category"}   {data.show.cat.req == '1' && '*'}                                           </label>
                                  <select
                                    className="form-control"
                                    type="text"
                                    {...register("catid", {
                                      required: data.show.cat.req == 1 ? "This is required" : false

                                    })}
                                    value={
                                      catid
                                    }
                                    onChange={(e) => {
                                      setcatid(e.target.value);
                                    }}
                                  >
                                    <option value="" selected>
                                      Select {data.show.cat.label !== "" ? data.show.cat.label.charAt(0).toUpperCase() + data.show.cat.label.slice(1) : "Category"}
                                    </option>
                                    {catData?.map(
                                      (ct) => (
                                        <option
                                          value={ct.cid}
                                          key={ct.cid}
                                        >
                                          {ct.cname}
                                        </option>
                                      )
                                    )}
                                  </select>
                                  {errors.catid && (
                                    <p className="text-error">
                                      {errors.catid.message}
                                    </p>
                                  )}
                                </div>
                              }
                              {(data != '' && data.show.icon.show == 1 && auctype == "0") &&
                                <div className="col-md-12 martop">
                                  <div className="row">
                                    <div className="col-md-2 margin-top-14px">
                                      <label htmlFor="">
                                        {" "}
                                        {data.show.icon.label !== "" ? data.show.icon.label.charAt(0).toUpperCase() + data.show.icon.label.slice(1) : "Playing style"}{data.show.icon.req == '1' && '*'}
                                      </label>
                                    </div>
                                    <div className="col-md-8 ">
                                      <div
                                        className={`roleclass form-group text-box-margin ${isTabletOrMobile || isPortrait
                                          ? "row"
                                          : null
                                          }`}
                                      >

                                        <div className="" >
                                          <img onClick={() => setisbat(!isbat)} src={bat} alt="" style={batstyle} />
                                        </div>
                                        <div className="" >
                                          <img onClick={() => setisbol(!isbol)} src={ball} alt="" style={bolstyle} />
                                        </div>
                                        <div className="">
                                          <img onClick={() => setiswkeep(!iswkeep)} src={wkeeper} alt="" style={wkeepstyle} />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }


                              <div className="col-md-12 margin-top-14px">
                                <div className="row">
                                  <div className="col-md-6">
                                    {data != '' && data.show.sp1.show == 1 &&

                                      <div className="row">
                                        <div className="form-group text-box-margin">
                                          <div className="col-md-4">
                                            <label htmlFor="spcf1">
                                              {" "}
                                              {data.show.sp1.label !== "" ? data.show.sp1.label.charAt(0).toUpperCase() + data.show.sp1.label.slice(1) : "Specification 1"}{data.show.sp1.req == '1' && '*'}{" "}
                                            </label>
                                          </div>
                                          {auctype != 0 ?
                                            <div className="col-md-8">
                                              {" "}
                                              <input
                                                placeholder="Specification 1"
                                                className="form-control"
                                                type="text"
                                                {...register("spcf1", {})}
                                              />
                                            </div>
                                            :
                                            <div className="col-md-6">
                                              {" "}
                                              <select
                                                className="form-control"
                                                id="spcf1"
                                                type="text"
                                                {...register("spcf1", {
                                                  required: data.show.sp1.req == 1 ? "This is required" : false

                                                })}
                                                onChange={(e) => {
                                                  if (e.target.value === "Other") {
                                                    setOtherBatting(true);
                                                  } else {
                                                    setOtherBatting(false);
                                                  }
                                                  setBatting(e.target.value);
                                                }}
                                              >
                                                <option value={""}>--select--</option>
                                                {sp1opt.map((ele) => (
                                                  <option value={ele}>
                                                    {ele}
                                                  </option>
                                                ))}
                                              </select>
                                              {errors.spcf1 && (
                                                <p className="text-error">
                                                  {errors.spcf1.message}
                                                </p>
                                              )}
                                            </div>}
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  {otherBatting ? (
                                    <div className="col-md-6">
                                      <div className="row form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            type="text"
                                            {...register("spcf1_other")}
                                            onChange={(e) =>
                                              setBatting(e.target.value)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>

                              <div className="col-md-12 margin-top-14px">
                                {data != '' && data.show.sp2.show == 1 &&

                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="row">
                                        <div className="form-group text-box-margin">
                                          <div className="col-md-4">
                                            <label htmlFor="spcf2">
                                              {" "}
                                              {data.show.sp2.label !== "" ? data.show.sp2.label.charAt(0).toUpperCase() + data.show.sp2.label.slice(1) : "Specification 2"}{data.show.sp2.req == '1' && '*'}{" "}
                                            </label>
                                          </div>
                                          {auctype != 0 ?
                                            <div className="col-md-8">
                                              {" "}
                                              <input
                                                placeholder="Specification 2"
                                                className="form-control"
                                                type="text"
                                                {...register("spcf2", {})}
                                              />
                                            </div>
                                            :
                                            <div className="col-md-6">
                                              {" "}
                                              <select
                                                className="form-control"
                                                id="spcf2"
                                                type="text"
                                                {...register("spcf2", {
                                                  required: data.show.sp2.req == 1 ? "This is required" : false

                                                })}
                                                onChange={(e) => {
                                                  if (e.target.value === "Other") {
                                                    setOtherBowling(true);
                                                  } else {
                                                    setOtherBowling(false);
                                                  }
                                                  setBowling(e.target.value);
                                                }}
                                              >
                                                <option value={""}>--select--</option>
                                                {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp3opt.map((ele) => (
                                                  <option value={ele}>
                                                    {ele}
                                                  </option>
                                                )) : sp2opt.map((ele) => (
                                                  <option value={ele}>
                                                    {ele}
                                                  </option>
                                                ))}
                                                <option value='Other'>
                                                  Other
                                                </option>
                                              </select>
                                              {errors.spcf2 && (
                                                <p className="text-error">
                                                  {errors.spcf2.message}
                                                </p>
                                              )}
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    {otherBowling ? (
                                      <div className="col-md-6">
                                        <div className="row form-group text-box-margin">
                                          <div className="col-md-4">
                                            <label htmlFor="spcf2"> Other </label>
                                          </div>
                                          <div className="col-md-8">
                                            <input
                                              placeholder="Other"
                                              className="form-control"
                                              // {...register("spcf2")}
                                              type="text"
                                              {...register("spcf2_other")}
                                              onChange={(e) =>
                                                setBowling(e.target.value)
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                }
                              </div>
                              {data != '' && data.show.sp3.show == 1 &&
                                <div className="row">
                                  <div className="col-md-6 margin-top-14px">
                                    <div className="form-group text-box-margin">
                                      <div className="col-md-4">
                                        <label htmlFor="spcf1">
                                          {" "}
                                          {data.show.sp3.label !== "" ? data.show.sp3.label.charAt(0).toUpperCase() + data.show.sp3.label.slice(1) : "Specification 3"}{data.show.sp3.req == '1' && '*'}{" "}
                                        </label>
                                      </div>
                                      {auctype != 0 ?
                                        <div className="col-md-8">
                                          {" "}
                                          <input
                                            placeholder="Specification 3"
                                            className="form-control"
                                            type="text"
                                            {...register("spcf3", {})}
                                          />
                                        </div>
                                        :
                                        <div className="col-md-6">
                                          {" "}
                                          <select
                                            className="form-control"
                                            id="spcf3"
                                            type="text"
                                            {...register("spcf3", {
                                              required: false,
                                              // required: "required field.",
                                            })}
                                            onChange={(e) => {
                                              if (e.target.value === "Other") {
                                                setOthersp3(true);
                                              } else {
                                                setOthersp3(false);
                                              }
                                              setsp3(e.target.value);
                                            }}
                                          >
                                            <option value={""}>--Specification 3--</option>
                                            {(batting == 'Bowling All Rounder' || batting == 'Bowler') ? sp2opt.map((ele) => (
                                              <option value={ele}>
                                                {ele}
                                              </option>
                                            )) : sp3opt.map((ele) => (
                                              <option value={ele}>
                                                {ele}
                                              </option>
                                            ))}

                                            <option value='Other'>
                                              Other
                                            </option>
                                          </select>
                                          {errors.spcf2 && (
                                            <p className="text-error">
                                              {errors.spcf2.message}
                                            </p>
                                          )}
                                        </div>
                                      }
                                    </div>
                                  </div>
                                  {othersp3 ? (
                                    <div className="col-md-6">
                                      <div className="row form-group text-box-margin">
                                        <div className="col-md-4">
                                          <label htmlFor="spcf2"> Other </label>
                                        </div>
                                        <div className="col-md-8">
                                          <input
                                            placeholder="Other"
                                            className="form-control"
                                            type="text"
                                            {...register("spcf3_other")}
                                            onChange={(e) =>
                                              setsp3(e.target.value)
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              }
                              {data != '' && data.show.detail.show == 1 &&

                                <div className="col-md-12">

                                  <div className="form-group text-box-margin">
                                    <label htmlFor="detail">
                                      {" "}
                                      {data.show.detail.label !== "" ? data.show.detail.label.charAt(0).toUpperCase() + data.show.detail.label.slice(1) : "Detail"}{data.show.detail.req == '1' && '*'}{" "}
                                    </label>
                                    <textarea
                                      className="form-control"
                                      id="other_details"
                                      {...register("detail", {
                                        required: data.show.detail.req == 1 ? "This is required" : false

                                      })}
                                    ></textarea>
                                  </div>

                                </div>
                              }

                              <div className="col-md-12">
                                <p><input type="checkbox" required style={{ 'min-height': '20px', 'margin-right': '10px' }} />Yes , I want to join</p>

                                <button
                                  className="button"
                                  onClick={() => (savenew = 0)}
                                  type="submit"
                                  style={{ width: "100%" }}
                                >
                                  Join Auction
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <NotFound data={""} />
      )}
    </div>
  )
}
